"use client"

import Link from "next/link"
import { Button } from "@/components/ui/button"
import { ThemeToggle } from "@/components/theme-toggle"
import { MobileNav } from "@/components/landing/mobile-nav"
import { usePathname } from "next/navigation"
import dynamic from "next/dynamic"
import Image from 'next/image'

// Lazy-load auth UI so Supabase JS is fetched only after hydration
const AuthButtons = dynamic(() => import("@/components/auth/AuthButtons"), {
  ssr: false,
  loading: () => (
    <div className="flex items-center gap-2">
      <div className="h-9 w-16 bg-muted rounded-md animate-pulse" />
      <div className="h-9 w-24 bg-primary/80 rounded-md animate-pulse" />
    </div>
  ),
})

export default function SiteHeader() {
  const pathname = usePathname()

  // Determine if we're on a page that uses hash navigation
  const isLandingPage = pathname === "/"

  return (
    <header className="sticky top-0 z-50 w-full border-b backdrop-blur-lg bg-background/80">
      <div className="container flex h-16 items-center justify-between px-4 md:px-6">
        <Link href="/" className="flex items-center gap-2">
          <Image 
            src="/images/white_icon_transparent_background (1).webp"
            alt="Brainpercent Logo"
            width={32} 
            height={32}
            className="h-8 w-8 object-contain" 
            priority
          />
          <span className="text-xl font-bold">Brainpercent</span>
        </Link>

        <nav className="hidden items-center space-x-6 text-sm font-medium md:flex">
          <Link href="/" className="transition-colors hover:text-foreground/80 text-foreground/60">
            Home
          </Link>
          <Link
            href="/articles"
            className="transition-colors hover:text-foreground/80 text-foreground/60"
          >
            Articles
          </Link>
          <Link 
            href="/pricing" 
            className="transition-colors hover:text-foreground/80 text-foreground/60"
          >
            Pricing
          </Link>
          <Link href="/about" className="transition-colors hover:text-foreground/80 text-foreground/60">
            About
          </Link>
          <Link href="/contact" className="transition-colors hover:text-foreground/80 text-foreground/60">
            Contact
          </Link>
          {/* Admin link removed from navigation - access directly via URL */}
        </nav>

        <div className="flex items-center gap-2 md:gap-4">
          <div className="hidden md:flex">
            <ThemeToggle />
          </div>
          
          {/* Auth buttons (lazy) */}
          <AuthButtons />
          
          {/* Keep MobileNav outside conditional rendering if it handles its own auth state */}
          <MobileNav />
        </div>
      </div>
    </header>
  )
}

